export class customerWizard {

  q1:any;
  q2:any;
  q3:any;
  q4:any;

}
